// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1fBKH","amount":"Amount_amount__11pQ9","tip":"Amount_tip__2wQtT","tipHeader":"Amount_tipHeader__19ljL","tipsWrap":"Amount_tipsWrap__2Rijv"};